import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircleIcon, XCircleIcon, ClockCountdownIcon } from "@phosphor-icons/react";

export default function PayPalReturn() {
  const [params] = useSearchParams();
  const token = params.get("token"); // PayPal order id
  const [state, setState] = useState({ status: "capturing" });
  const done = useRef(false);

  useEffect(() => {
    if (done.current || !token) return;
    done.current = true;
    (async () => {
      try {
        const { data } = await api.post("/payments/paypal/capture", { paypal_order_id: token });
        if (data.paid) setState({ status: "paid" });
        else setState({ status: "pending", raw: data });
      } catch (e) {
        setState({ status: "error", error: e?.response?.data?.detail || "Capture failed" });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="paypal-return-page">
      <Navbar />
      <main className="flex-1 max-w-2xl mx-auto w-full px-6 py-16">
        {state.status === "capturing" && (
          <div className="text-center">
            <ClockCountdownIcon size={56} className="mx-auto text-[#1D78AB]" />
            <h1 className="font-display font-black text-3xl mt-4">Capturing your PayPal payment…</h1>
            <p className="text-zinc-600 mt-2">Hang tight, this takes a second.</p>
          </div>
        )}
        {state.status === "paid" && (
          <div className="text-center">
            <CheckCircleIcon size={64} weight="fill" className="mx-auto text-emerald-500" />
            <h1 className="font-display font-black text-4xl mt-4">Payment complete</h1>
            <p className="text-zinc-600 mt-2">Your PayPal payment was captured. The seller has been notified.</p>
            <div className="mt-6 flex gap-3 justify-center">
              <Link to="/orders"><Button className="bg-[#1D78AB] hover:bg-[#165d85] text-white">View order</Button></Link>
              <Link to="/browse"><Button variant="outline">Keep browsing</Button></Link>
            </div>
          </div>
        )}
        {(state.status === "pending" || state.status === "error") && (
          <div className="text-center">
            <XCircleIcon size={56} className="mx-auto text-red-500" />
            <h1 className="font-display font-black text-3xl mt-4">Payment not completed</h1>
            <p className="text-zinc-600 mt-2">{state.error || "The PayPal capture didn't complete. Please try again."}</p>
            <Link to="/browse" className="inline-block mt-6"><Button variant="outline">Back to marketplace</Button></Link>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
